import * as React from "react"
import Layout from "../components/Layout"
import Button from "../components/Button"
import { Link } from "gatsby"
import Seo from "../components/Seo";
import '../styles/index.css'

import { ChevronRightIcon } from '@heroicons/react/outline'
import NyseLogoCloud from "../components/NyseLogoCloud"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { FadeIn, FadeInStagger } from "../components/FadeIn"


const features = [
  {
    name: 'NYSE® OPEN Venture Capital Unicorn® Index',
    description:
      'The NYSE® OPEN Venture Capital Unicorn® Index is a modified market capitalization-weighted index designed to track the 50 largest U.S. venture capital backed private companies with valuations of $1 billion or greater.',
    href: '/unicorn-index',
    icon: ChevronRightIcon,
  },
  {
    name: 'NYSE® OpenVC™ 500 Index',
    description:
      "The NYSE® OpenVC™ 500 Index is a rules-based, modified market capitalization-weighted benchmark of the 500 largest U.S. companies as selected from listed U.S. companies, and venture capital backed private companies with valuations of $1 billion or greater.",
    href: '/nyse-openvc-500-index',
    icon: ChevronRightIcon,
  },
]

const stats = [
  { id: 1, name: 'Unicorns in OpenVC™\'s universe', value: '1300+' },
  { id: 2, name: 'Private market value tracked', value: '$3 tn+' },
  { id: 3, name: 'Sectors covered', value: '12' },
]


const posts = [
  {
    id: 1,
    title: 'OpenVC™ Unicorn® 50 Index Fund',
    imageUrl: 'https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg',
    href: '#',
    description: 'The OPEN Unicorn® Index Fund (UIF) is a venture fund that tracks OpenVC™\'s overlying index of the Top 50 US-domiciled venture-backed private companies.',
  },
  {
    id: 3,
    title: 'OpenVC™ Pegasus - Custom Investments',
    imageUrl: 'https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg',
    href: '#',
    description: 'Invest like the best; Take advantage of OpenVC™\'s expertise to construct custom portfolios that meet your investment objectives.',
  },
  {
    id: 3,
    title: 'OpenVC™ Unicorn® 50 Index',
    imageUrl: 'https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg',
    href: '#',
    description: 'The OpenVC™ Unicorn® Index is a capitalization-weighted index comprised of the largest 50 venture capital backed private companies domiciled in the United States.',
  },
]

const PostArticle = ({ post }) => (
  <article className="flex flex-col items-center justify-center">
    <div className="relative w-40 border-4 rounded-lg bg-white">
      <img src={post.imageUrl} alt="" className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]" />
      <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
    </div>
    <div className="max-w-xl">
      <div className="group relative">
        <h3 className="mt-8 text-xl md:text-3xl leading-9 text-gray-900 group-hover:text-gray-600">
          <Link to={post.href}><span className="absolute inset-0" />{post.title}</Link>
        </h3>
        <p className="mt-5 text-md md:text-xl leading-7 text-gray-600">{post.description}</p>
      </div>
    </div>
  </article>
);

const incomingDataPaths = [
  'M52 24 C116 48 174 120 246 166',
  'M24 58 C104 78 172 128 246 172',
  'M48 102 C126 114 188 150 246 180',
  'M18 156 C106 160 180 176 246 186',
  'M40 208 C120 202 184 194 246 192',
  'M28 260 C118 244 180 210 246 198',
  'M68 314 C134 280 190 222 246 204',
  'M118 346 C158 296 204 232 246 210',
];

const signalPath = 'M452 186 C510 158 548 114 614 126 C676 140 710 86 786 92';

const incomingDataParticles = [
  { pathIndex: 0, radius: 2.5, duration: '4.6s', delay: '-.2s' },
  { pathIndex: 0, radius: 1.8, duration: '4.6s', delay: '-2.4s', muted: true },
  { pathIndex: 0, radius: 1.5, duration: '4.6s', delay: '-3.5s', muted: true },
  { pathIndex: 1, radius: 2.2, duration: '4.1s', delay: '-1.1s' },
  { pathIndex: 1, radius: 1.7, duration: '4.1s', delay: '-3.2s', muted: true },
  { pathIndex: 1, radius: 1.5, duration: '4.1s', delay: '-.1s', muted: true },
  { pathIndex: 2, radius: 2.4, duration: '4.4s', delay: '-.7s' },
  { pathIndex: 2, radius: 1.7, duration: '4.4s', delay: '-2.6s', muted: true },
  { pathIndex: 2, radius: 1.5, duration: '4.4s', delay: '-3.7s', muted: true },
  { pathIndex: 3, radius: 2.7, duration: '3.8s', delay: '-.4s' },
  { pathIndex: 3, radius: 1.8, duration: '3.8s', delay: '-2.2s', muted: true },
  { pathIndex: 3, radius: 1.5, duration: '3.8s', delay: '-3.1s', muted: true },
  { pathIndex: 4, radius: 2.4, duration: '4s', delay: '-1.5s' },
  { pathIndex: 4, radius: 1.7, duration: '4s', delay: '-3.3s', muted: true },
  { pathIndex: 4, radius: 1.5, duration: '4s', delay: '-.4s', muted: true },
  { pathIndex: 5, radius: 2.3, duration: '4.3s', delay: '-.9s' },
  { pathIndex: 5, radius: 1.7, duration: '4.3s', delay: '-2.8s', muted: true },
  { pathIndex: 5, radius: 1.5, duration: '4.3s', delay: '-3.8s', muted: true },
  { pathIndex: 6, radius: 2.5, duration: '4.7s', delay: '-1.4s' },
  { pathIndex: 6, radius: 1.8, duration: '4.7s', delay: '-3.5s', muted: true },
  { pathIndex: 6, radius: 1.5, duration: '4.7s', delay: '-.3s', muted: true },
  { pathIndex: 7, radius: 2.2, duration: '5s', delay: '-.6s' },
  { pathIndex: 7, radius: 1.6, duration: '5s', delay: '-3.1s', muted: true },
  { pathIndex: 7, radius: 1.4, duration: '5s', delay: '-4.2s', muted: true },
];

const signalDots = [
  { radius: 3.2, duration: '4.2s', delay: '-.2s' },
  { radius: 2.5, duration: '4.2s', delay: '-1.6s' },
  { radius: 3, duration: '4.2s', delay: '-3s' },
];

const IndexPage = () => {
  return (
    <Layout transparentAtTop={true} hideFooter={false}>
      <Seo title="Home" description="Indexing and investment solutions for venture capital. OpenVC™ is bringing the revolutionary idea of index investing and benchmarking to late-stage venture & growth. We manage funds investing in some of the world's most sought after investments." />
      <div className="bg-gray-100 relative">
        <div className="mx-auto max-w-7xl flex h-[620px] md:pl-16 items-center bg-gray-100">
          <div className="max-w-2xl">
            <FadeIn>
              <div className="max-w-lg px-6 lg:px-0">
                <div className="invisible sm:visible relative  w-fit flex items-center gap-x-4 rounded-full px-4 py-1 text-sm leading-6 text-gray-600 ring-1 ring-green-900/10 bg-green-500/10">
                  <span className="relative inline-flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                  </span>
                  <span className="font-semibold text-gray-600">NEW - NYSE® OpenVC™ 500 Index</span>
                  <span className="h-4 w-px bg-green-900/10" aria-hidden="true" />
                  <span className="absolute inset-0" aria-hidden="true" />
                  <Link to="/nyse-openvc-500-index" className="font-semibold text-green-900">
                    <span className="absolute inset-0" aria-hidden="true" />
                    View <span aria-hidden="true">&rarr;</span>
                  </Link>
                </div>
                <h1 className="text-center sm:text-left mt-5 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  Indexing and investment solutions for venture capital.
                </h1>

                <p className="text-center sm:text-left mt-6 text-xl leading-8 text-gray-600">
                  OpenVC™ is bringing the revolutionary idea of index investing and benchmarking to late-stage venture & growth.
                  We manage funds investing in some of the world's most sought after investments.
                </p>
                <div >
                  <AnchorLink to="/#solutions" stripHash={true}>
                    <Button classes='px-5 mt-12 w-full sm:w-fit'>View our solutions</Button>
                  </AnchorLink>
                </div>
              </div>
            </FadeIn>
          </div>
          <div className="absolute h-full right-slant w-full flex-1 bg-[url('../images/raster-bg-alone-2x.png')] bg-cover bg-primary">
            <div className="hero-data-visual" aria-hidden="true">
              <svg viewBox="0 0 820 360" role="img" className="h-full w-full" preserveAspectRatio="xMidYMid meet">
                <defs>
                  <pattern id="hero-data-grid" width="28" height="28" patternUnits="userSpaceOnUse">
                    <path d="M28 0H0V28" fill="none" stroke="rgba(255,255,255,.08)" strokeWidth="1" />
                  </pattern>
                  <linearGradient id="hero-data-stream" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#FFFFFF" stopOpacity=".15" />
                    <stop offset="58%" stopColor="#F3AB3C" stopOpacity=".8" />
                    <stop offset="100%" stopColor="#FFFFFF" stopOpacity=".9" />
                  </linearGradient>
                  <linearGradient id="hero-signal-stream" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stopColor="#FFFFFF" stopOpacity=".3" />
                    <stop offset="42%" stopColor="#F3AB3C" />
                    <stop offset="100%" stopColor="#FFFFFF" />
                  </linearGradient>
                  <radialGradient id="hero-core-fill" cx="50%" cy="50%" r="68%">
                    <stop offset="0%" stopColor="#8F2D71" />
                    <stop offset="100%" stopColor="#631449" />
                  </radialGradient>
                  <filter id="hero-glow" x="-35%" y="-35%" width="170%" height="170%">
                    <feGaussianBlur stdDeviation="6" result="coloredBlur" />
                    <feMerge>
                      <feMergeNode in="coloredBlur" />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>

                <rect width="820" height="360" fill="url(#hero-data-grid)" className="data-grid" />
                <circle cx="314" cy="178" r="178" fill="#FFFFFF" className="ambient-ring" />
                <circle cx="514" cy="134" r="126" fill="#F3AB3C" className="ambient-ring ambient-ring-accent" />

                <g>
                  {incomingDataPaths.map((path, index) => (
                    <path key={path} d={path} className={`data-stream stream-${index + 1}`} />
                  ))}
                  {incomingDataParticles.map((particle, index) => (
                    <circle key={`data-particle-${index}`} r={particle.radius} className={`data-particle${particle.muted ? ' data-particle-muted' : ''}`}>
                      <animateMotion dur={particle.duration} repeatCount="indefinite" begin={particle.delay} path={incomingDataPaths[particle.pathIndex]} />
                      <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;0.12;0.82;1" dur={particle.duration} repeatCount="indefinite" begin={particle.delay} />
                    </circle>
                  ))}
                </g>

                <g className="index-core" filter="url(#hero-glow)">
                  <rect x="246" y="112" width="206" height="148" rx="14" className="core-shell" />
                  <rect x="266" y="132" width="166" height="108" rx="9" className="core-screen" />
                  <path d="M292 198 C314 172 336 220 358 190 C382 158 404 180 424 156" className="core-sparkline" />
                  <g className="core-bars">
                    <rect x="294" y="210" width="14" height="15" rx="2" />
                    <rect x="316" y="202" width="14" height="23" rx="2" />
                    <rect x="338" y="214" width="14" height="11" rx="2" />
                    <rect x="360" y="194" width="14" height="31" rx="2" />
                    <rect x="382" y="184" width="14" height="41" rx="2" />
                  </g>
                  <path d="M281 181h56M353 181h28M394 181h22" className="core-lines" />
                </g>

                <path d={signalPath} className="signal-base" />
                <path d={signalPath} className="signal-line" />
                <g className="signal-dots">
                  {signalDots.map((dot, index) => (
                    <circle key={`signal-dot-${index}`} r={dot.radius} className="signal-dot">
                      <animateMotion dur={dot.duration} repeatCount="indefinite" begin={dot.delay} path={signalPath} />
                      <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;0.12;0.84;1" dur={dot.duration} repeatCount="indefinite" begin={dot.delay} />
                    </circle>
                  ))}
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <FadeInStagger>
        <div className="bg-white py-16 sm:py-24" >
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <FadeIn>
              <div className="mx-auto max-w-2xl lg:text-center" id="solutions">
                <h2 className="text-base font-semibold leading-7 text-primary">Our Solutions</h2>
                <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  Empowering investment and insights in late-stage venture.
                </p>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                OpenVC's data and indices provide insights and a comprehensive view of the private market. OpenVC™ is an asset manager that manages a low-fee, index-based fund that provides diversified exposure to the 20 largest US-based private tech companies.
                </p>
              </div>
            </FadeIn>
            <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
              <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
                {features.map((feature) => (
                  <FadeIn key={feature.name}>
                    <div className="flex flex-col">
                      <dt className="flex items-center gap-x-3 text-lg font-semibold leading-7 text-gray-900">
                        <feature.icon className="h-5 w-5 flex-none text-indigo-600" aria-hidden="true" />
                        {feature.name}
                      </dt>
                      <dd className="mt-4 flex flex-auto flex-col text-base leading-7 text-gray-600">
                        <p className="flex-auto">{feature.description}</p>
                        <p className="mt-6">
                          <Link to={feature.href} className="text-sm text-primary font-semibold leading-6 text-indigo-400">
                            Learn more <span aria-hidden="true">→</span>
                          </Link>
                        </p>
                      </dd>
                    </div>
                  </FadeIn>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </FadeInStagger>

      <FadeInStagger>
        <div className="bg-gray-50 py-24 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
              {stats.map((stat) => (
                <FadeIn key={stat.id}>
                  <div className="mx-auto flex max-w-xs flex-col gap-y-4">
                    <dt className="text-base leading-7 text-gray-600">{stat.name}</dt>
                    <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                      {stat.value}
                    </dd>
                  </div>
                </FadeIn>
              ))}
            </dl>
          </div>
        </div>
      </FadeInStagger>

      <FadeInStagger>
        <div className="bg-primary bg-cover bg-[url('../images/raster-bg-alone-2x.png')]">
          <div className="mx-auto max-w-7xl px-6 py-20 sm:py-24 lg:flex lg:items-center lg:justify-between lg:px-8">
            <FadeIn>
              <h2 className="text-white text-3xl font-bold tracking-tight sm:text-4xl">
                Stay updated:<br />
                Join our mailing list
              </h2>
            </FadeIn>
            <FadeIn>
              <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
                <form name="mailing" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" action="/lead-form-success" className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 w-full">
                  <input type="hidden" name="form-name" value="mailing" />
                  <input className="hidden" name="bot-field" />
                  <input type="hidden" id="gclid_field" name="gclid_field" value=""></input>
                  <div className="grid grid-cols-1 md:col-span-2 gap-6 w-full justify-self-end">
                    <input className="bg-transparent appearance-none border border-gray-100 w-full py-2 px-4 text-white focus:outline-none focus:bg-white/10 focus:border-accent placeholder-white/80 h-12" type="email" name="email" required placeholder="Email" />
                  </div>
                  <div className="grid grid-cols-1 md:col-span-2 gap-6">
                    <Button classes='text-white px-3 sm:px-16'>Join Mailing List</Button>
                  </div>
                </form>
              </div>
            </FadeIn>
          </div>
        </div>
      </FadeInStagger>

    </Layout>
  )
}

export default IndexPage
